<template>
    <div style="height: 100%">
        <prospect-list :prospects="prospects" />

        <prospect-map
            style="width: 100%; height: 100%;"
            :prospects="prospects"
            :can-draw="true"
        />

        <div v-if="polygons.length > 0" class="absolute items-center pin-x pin-b p-lg bg-white shadow flex flex-wrap justify-between rounded w-2/3 md:w-auto">
            <div>
                Ritade prospektområden: {{ polygons.length }}
            </div>
            <div class="flex flex-wrap-reverse">
                <button class="btn btn-md is-ghost md:mr-md" @click="cancelCreation">
                    Avbryt
                </button>
                <button class="btn btn-md is-primary my-sm md:my-0" @click="showCreateModal">
                    Spara
                </button>
            </div>
        </div>

        <adaptive-form-modal
            name="create-prospect"
            :callback="redirectToCreatedProspect"
            primary-button-text="Skapa område"
            action="/prospects"
        >
            <input
                v-for="polygon in polygons"
                type="hidden"
                name="polygons[]"
                :value="polygon"
            >
            <text-input
                v-model="newAreaName"
                :required="true"
                :autofocus="true"
                name="name"
                label="Områdesnamn"
            />
        </adaptive-form-modal>

        <adaptive-modal name="prospect-details" :hide-action-buttons="true">
            <div v-if="selectedProspect" class="flex items-center flex-col">
                <h2 class="headline-lg">
                    {{ selectedProspect.name }}
                </h2>

                <div :class="`text-${selectedProspect.status_color}`" class="text-xs mt-xs">
                    {{ selectedProspect.status_label }}
                </div>

                <button
                    type="button"
                    class="btn btn-md is-primary mt-lg"
                    @click="goToSelectedProspect"
                >
                    Visa område
                </button>
            </div>
        </adaptive-modal>
    </div>
</template>
<script>
    import ProspectList from './Sidebars/ProspectList';

    export default {
        components: { ProspectList },
        props: {
            center: {
                required: false,
                type: Object,
                default: () => {
                    return window.defaultMapCenter;
                },
            },
            zoom: {
                type: [Number, String],
                default: 5,
            },
            mapHeight: {
                type: String,
                default: '470px',
            },
            markers: {
                type: Array,
                default: () => {
                    return [];
                },
            },
        },
        data() {
            return {
                newAreaName: null,
                selectedProspect: null,
                showSidebar: false,
                prospects: [],
                errorFetchingProspects: false,
                polygons: [],
                drawnShapes: [],
                options: {
                    mapTypeControl: false,
                    streetViewControl: false,
                },
            };
        },
        mounted() {
            this.fetchProspects();

            EventBus.$on(
                'selected-prospect',
                options => this.showProspectInformationModal(options),
            );

            EventBus.$on(
                'shape-drawn',
                (options, shape) => this.addPolygon(options, shape),
            );
        },
        methods: {
            async fetchProspects() {
                this.errorFetchingProspects = false;
                const response = await axios.get(route('api.prospects.index'));

                try {
                    this.prospects = response.data;
                } catch (error) {
                    this.errorFetchingProspects = true;
                }
            },
            redirectToCreatedProspect(response) {
                window.location = route('admin.prospects.show', response.data.id);
            },
            showProspectInformationModal(shapeId) {
                this.selectedProspect = this.prospects.find((prospect) => {
                    return prospect.id === shapeId;
                });

                if (! this.selectedProspect) {
                    return;
                }

                this.$modal.show('prospect-details');
            },
            goToSelectedProspect() {
                window.location = route('admin.prospects.show', this.selectedProspect.id);
            },
            addPolygon(coordinates, shape) {
                this.polygons.push(coordinates);
                this.drawnShapes.push(shape);
            },
            showCreateModal() {
                this.$modal.toggle('create-prospect');
            },
            cancelCreation() {
                EventBus.$emit('clear-user-created-shapes', this.drawnShapes);
                this.drawnShapes = [];
                this.polygons = [];
            },
        },
    };
</script>